import { z } from "zod/v3";
import { EXPENSE_IMPORT_MAPPING_NONE } from "../constants";
import type { ExpenseImportTypeCode } from "../types";
import { EXPENSE_TYPE_CODES } from "../types";

const expenseImportTypeSchema = z
	.number()
	.refine(
		(val) =>
			Object.values(EXPENSE_TYPE_CODES).includes(val as ExpenseImportTypeCode),
		{ message: "Selecione o tipo de despesa" }
	);

const mappingValueSchema = z.union([
	z.string().min(1),
	z.literal(EXPENSE_IMPORT_MAPPING_NONE),
	z.null(),
	z.literal(""),
]);

export const expensesImportSchema = z
	.object({
		type: expenseImportTypeSchema.optional().nullable(),
		documentType: z.enum(["spreadsheet", "pdf"]),
		file: z.instanceof(File).nullable(),
		mapping: z.record(z.string(), mappingValueSchema).optional(),
	})
	.superRefine((data, ctx) => {
		if (data.documentType === "spreadsheet" && !data.file) {
			ctx.addIssue({
				code: z.ZodIssueCode.custom,
				message: "Selecione um arquivo para continuar.",
				path: ["file"],
			});
		}
	});

export type ExpensesImportSchema = z.infer<typeof expensesImportSchema>;
